import { render, staticRenderFns } from "./TagAction.vue?vue&type=template&id=373c29cb&scoped=true"
import script from "./TagAction.vue?vue&type=script&lang=js"
export * from "./TagAction.vue?vue&type=script&lang=js"
import style0 from "./TagAction.vue?vue&type=style&index=0&id=373c29cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c29cb",
  null
  
)

export default component.exports